export default __webpack_public_path__ + "static/media/import.7514864f.svg";